import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Offer, PromotersOffer } from "../../types";
import { routes } from "../../routes/routes";
import { defaultImgs } from "../../utils/defaultImages";
import { getUserAvatar } from "../../utils/getMedia";
import styles from "./myPartyDetail.module.scss";

const VIP_OFFER_TYPE = "JoinVIPTable";

type ReceivedVipTableOffer = {
    offerId: string;
    clubName: string;
    senderName: string;
    senderId: string;
    isAccepted: boolean;
    promoterOffer: PromotersOffer;
    offer: Offer;
};

const flattenVipOffers = (promotersOffers: PromotersOffer[]): ReceivedVipTableOffer[] =>
    promotersOffers.flatMap((promoterOffer) =>
        promoterOffer.offers
            .filter((offer) => offer.offerType === VIP_OFFER_TYPE)
            .map((offer) => ({
                offerId: offer.id,
                clubName: offer.clubName,
                senderName: promoterOffer.promoter.FirstName,
                senderId: promoterOffer.promoter.id,
                isAccepted: offer.isAccepted,
                promoterOffer,
                offer,
            }))
    );

export default function ReceivedVipTableOffers({
    partyId,
    cityName,
    promotersOffers,
}: {
    partyId: string;
    cityName: string;
    promotersOffers: PromotersOffer[];
}) {
    const navigate = useNavigate();

    const vipOffers = useMemo(() => flattenVipOffers(promotersOffers), [promotersOffers]);

    if (vipOffers.length === 0) {
        return null;
    }

    const handleOpen = (item: ReceivedVipTableOffer) => {
        navigate(routes.OfferDetails(partyId, item.offerId), {
            state: {
                promoter: item.promoterOffer.promoter,
                city: cityName,
                offer: item.offer,
            },
        });
    };

    return (
        <section className={styles.vipOffersSection} aria-label="VIP table invites">
            <h3 className={styles.vipOffersTitle}>VIP Table Invites</h3>
            <ul className={styles.vipOffersList}>
                {vipOffers.map((item) => (
                    <li key={item.offerId} className={styles.vipOfferItem}>
                        <button
                            type="button"
                            className={styles.vipOfferButton}
                            onClick={() => handleOpen(item)}
                        >
                            <img
                                className={styles.vipOfferAvatar}
                                src={getUserAvatar(item.senderId) ?? defaultImgs.Avatar}
                                alt=""
                                onError={(event) => { (event.target as HTMLImageElement).src = defaultImgs.Avatar; }}
                            />
                            <div className={styles.vipOfferText}>
                                <span className={styles.vipOfferClub}>{item.clubName}</span>
                                <span className={styles.vipOfferSender}>From {item.senderName}</span>
                            </div>
                            <span className={item.isAccepted ? styles.vipOfferStatusAccepted : styles.vipOfferStatusPending}>
                                {item.isAccepted ? "Accepted" : "View & Accept"}
                            </span>
                        </button>
                    </li>
                ))}
            </ul>
        </section>
    );
}
